import { useI18n } from '@app-velocity/i18n';
import { RepeatIcon } from '@app-velocity/icons';
import { MessageBus } from '@app-velocity/message-bus';
import { Button } from '@app-velocity/ui';

const messageBus = new MessageBus('prototypes');

export type MoveFigmaReportButtonProps = {
  id: string;
};

export const MoveFigmaReportButton = ({ id }: MoveFigmaReportButtonProps) => {
  const { t } = useI18n();

  const onClick = () => {
    messageBus.publish('modal:move-figma-report:open', { id });
  };

  return (
    <Button variant="reportAction" color="default" onClick={onClick}>
      <RepeatIcon />
      {t('shared:transfer')}
    </Button>
  );
};
